'use client';

export type ClientTrackingDebugMeta = {
  pipeline?: string;
  schemaMap?: string;
  specValidated?: boolean;
};

type ClientTrackingDebugEntry =
  | {
      anonymousId?: string;
      emitter: 'client';
      kind: 'identify';
      pipeline: string;
      traits?: Record<string, unknown>;
      userId?: string;
    }
  | {
      anonymousId?: string;
      emitter: 'client';
      eventName: string;
      kind: 'track';
      pipeline: string;
      properties?: Record<string, unknown>;
      schemaMap?: string;
      specValidated?: boolean;
      userId?: string;
    };

const TRACKING_DEBUG_ENDPOINT = '/api/tracking-debug';

export function isClientTrackingDebugEnabled(): boolean {
  return (
    typeof window !== 'undefined' && process.env.NEXT_PUBLIC_TRACKING_DEBUG_LOCAL_WRITE === '1'
  );
}

export function debugLogClientTracking(entry: ClientTrackingDebugEntry): void {
  if (!isClientTrackingDebugEnabled()) {
    return;
  }

  void fetch(TRACKING_DEBUG_ENDPOINT, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(entry),
    keepalive: true,
  }).catch(() => {
    // Best-effort local debug logging should never affect gameplay.
  });
}
